import { render, staticRenderFns } from "./Collectives.vue?vue&type=template&id=6b099b31"
import script from "./Collectives.vue?vue&type=script&lang=js"
export * from "./Collectives.vue?vue&type=script&lang=js"
import style0 from "./Collectives.vue?vue&type=style&index=0&id=6b099b31&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports